/*
 * @Author: your name
 * @Date: 2021-11-24 10:48:52
 * @LastEditTime: 2021-11-24 11:50:08
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/store/module/demand/mutation.js
 */
import * as Types from '../../mutations-types'
 
  export default {
    [Types.GET_SEARCH_DEMAND_LIST] (state, res) {
      state.searchDemandList = res
    }
  }